import { SHButton, SHDialog, SHStack } from "@components/design-systems";

type Props = {
  open: boolean;
  onClose: () => void;
};
export const NoProductShortlistedDialog = ({ open, onClose }: Props) => {
  return (
    <SHDialog
      open={open}
      maxWidth={false}
      width={550}
      disableEscapeKeyDown
      disableBackdropClick
      header={"At least one platform must be shortlisted"}
      body={
        "In order to proceed to the next stage, please shortlist at least one platform."
      }
      footer={
        <SHStack justifyContent="center" alignItems="center" direction={"row"}>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onClose}
            sx={{ width: "50%" }}
          >
            OK
          </SHButton>
        </SHStack>
      }
    />
  );
};
